export default __webpack_public_path__ + "static/media/Lata-Mangeshkar.1a8ba532.jpg";